export const addBracketParameterToUrl = (url: string, parameter: string) => {
  if (url.includes('?')) {
    return `${url}&${parameter}`;
  }

  return `${url}?${parameter}`;
};
